import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { listProducts } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Loader2 } from "lucide-react";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [sort, setSort] = useState("featured");

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    listProducts({ search: q, sort, limit: 60 })
      .then((data) => {
        if (!mounted) return;
        setItems(data.items || []);
        setTotal(data.total || 0);
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, [q, sort]);

  return (
    <main className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10" data-testid="search-page">
      <nav className="text-xs text-neutral-500 mb-3">
        <Link to="/" className="hover:text-neutral-900">Home</Link>
        <span className="mx-2">/</span>
        <span className="text-neutral-900 font-medium">Search</span>
      </nav>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
        <div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter">
            Results for <span className="brand-red">&quot;{q}&quot;</span>
          </h1>
          <p className="text-neutral-600 mt-2 text-sm" data-testid="search-count">
            {loading ? "Searching…" : `${total.toLocaleString()} products found`}
          </p>
        </div>
        <select
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          className="h-10 rounded-md border border-neutral-300 bg-white px-3 text-sm focus:outline-none focus:border-neutral-900"
          data-testid="search-sort"
        >
          <option value="featured">Featured</option>
          <option value="price_asc">Price: Low to High</option>
          <option value="price_desc">Price: High to Low</option>
          <option value="rating">Highest Rated</option>
        </select>
      </div>

      {loading ? (
        <div className="py-24 flex items-center justify-center text-neutral-500">
          <Loader2 className="animate-spin mr-2" size={18} />
          Loading…
        </div>
      ) : items.length === 0 ? (
        <div className="py-24 text-center text-neutral-500 border border-dashed border-neutral-300 rounded-xl">
          No fictional products matched your search.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="search-results">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </main>
  );
}
